import { render } from "./SubscriptionsShowView.vue?vue&type=template&id=0b6c0cba&scoped=true"
import script from "./SubscriptionsShowView.vue?vue&type=script&lang=js"
export * from "./SubscriptionsShowView.vue?vue&type=script&lang=js"

import "./SubscriptionsShowView.vue?vue&type=style&index=0&id=0b6c0cba&scoped=true&lang=css"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6c0cba"]])

export default __exports__